export class Relocation {
    constructor({
        relocationID = 0,
        orderID = 0,
        relocationDetails = {},
        guid = "00000000-0000-0000-0000-000000000000",
        dealerID = 0,
        status = '',
        _relocationGuidURL = '',
    } = {}) {
        this.relocationID = relocationID;
        this.orderID = orderID;
        this.relocationDetails = relocationDetails;
        this.guid = guid;
        this.dealerID = dealerID;
        this.status = status;
        this._relocationGuidURL = _relocationGuidURL;
    }
}

export function createRelocation(data) {
    return Object.freeze(new Relocation(data));
}